<button class="td-wb-joyride-close-button"
        tdWbButton
        tdWbButtonType="icon"
        [attr.aria-label]="'tdWb.core.joyride.step.CLOSE' | translate"
        (click)="onClick()">
  <td-wb-icon iconId="close--small" iconType="primary2" size="15"></td-wb-icon>
</button>
